import { withTaxIdBesideYearBuilt } from '../../shared';
import type { ListingLocaleOverrides } from '../base';

export const TXOverrides: ListingLocaleOverrides = {
  locale: 'TX',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            withTaxIdBesideYearBuilt(layout).concat([
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.lot',
                  size: 50,
                },
                {
                  name: 'property.block',
                  size: 50,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText:
                'Copy legal description from appraisal district site. Be sure lot and block is only included in the lot and block fields above and does not repeat in this field...',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
            lot: {
              name: 'property.lot',
              entity: 'property',
              type: 'text',
              label: 'Lot',
              placeholderText: '',
            },
            block: {
              name: 'property.block',
              entity: 'property',
              type: 'text',
              label: 'Block',
              placeholderText: '',
            },
            county: {
              validation: () => [],
            },
          },
        },
      },
    },
  },
};
